module.exports = __webpack_public_path__ + "static/NightInTheWoods5-46108da915674fc9d73680985a661645.png";